<template>
    <el-drawer v-model="authshow" size="30%" direction="rtl" :before-close="handleClose">
        <el-empty description="会员还未认证" v-if="authinfo.auth_id==0" />

        <!-- 实名认证 -->
        <div class="auth-box" v-if="authinfo.auth_id==1">
            <div class="auth-box-item">
                <div class="auth-title">
                认证情况
                <span :class="authinfo.auth_status==2 ? 'left10 auth-status' : 'left10'">{{authinfo.auth_status_name}}</span>
                </div>
            </div>
            <div class="auth-box-item top40">
                <div class="auth-box-content-title">姓名</div>
                <div class="auth-box-content left20">{{authinfo.auth_id_name}}</div>
            </div>
            <div class="auth-box-item top20">
                <div class="auth-box-content-title">身份证号</div>
                <div class="auth-box-content left20">{{authinfo.auth_id_card}}</div>
            </div>
            <div class="auth-box-item top20">
                <div class="auth-box-content-title">认证时间</div>
                <div class="auth-box-content left20">{{authinfo.auth_time}}</div>
            </div>
        </div>

        <!-- 企业认证 -->
        <div class="auth-box" v-if="authinfo.auth_id==2">
            <div class="auth-box-item">
                <div class="auth-title">
                认证情况
                <span :class="authinfo.auth_status==2 ? 'left10 auth-status' : 'left10'">{{authinfo.auth_status_name}}</span>
                <span class="auth-error left05" v-if="authinfo.auth_status==3">{{authinfo.auth_error_reason}}</span>
                </div>
            </div>
            <div class="auth-box-item top40" style="display:inline-block">
                <wcimage :option="{size:'middle',showBig:true}" :value="item.url" v-for="(item,index) in authinfo.auth_business_license" :key="index" class="right10" style="margin-bottom:10px" />
            </div>
            <div class="auth-box-item top20">
                <div class="auth-box-content-title">主体名称</div>
                <div class="auth-box-content left20">{{authinfo.auth_business_shopname}}</div>
            </div>
            <div class="auth-box-item top20">
                <div class="auth-box-content-title">主体类型</div>
                <div class="auth-box-content left20">{{authinfo.auth_business_shoptype}}</div>
            </div>
            <div class="auth-box-item top20">
                <div class="auth-box-content-title">执照注册号</div>
                <div class="auth-box-content left20">{{authinfo.auth_business_node}}</div>
            </div>
            <div class="auth-box-item top20">
                <div class="auth-box-content-title">联系电话</div>
                <div class="auth-box-content left20">{{authinfo.auth_business_phone}}</div>
            </div>
            <div class="auth-box-item top20">
                <div class="auth-box-content-title">认证金额</div>
                <div class="auth-box-content left20">{{authinfo.auth_business_price}}</div>
            </div>
            <div class="auth-box-item top20">
                <div class="auth-box-content-title">认证时间</div>
                <div class="auth-box-content left20">{{authinfo.auth_time}}</div>
            </div>
            <div class="auth-box-item top20">
                <div class="auth-box-content-title">认证时效</div>
                <div class="auth-box-content left20">{{authinfo.auth_expire_time}}</div>
            </div>
            <div class="auth-box-item top20">
                <div class="auth-box-content-title">认证截至日期</div>
                <div class="auth-box-content left20">{{authinfo.auth_expire_time}}</div>
            </div>
            <div class="auth-box-item top20">
                <div class="auth-box-content-title">微信支付订单号</div>
                <div class="auth-box-content left20">{{authinfo.transaction_id}}</div>
            </div>
        </div>


    </el-drawer>
</template>

<script>
export default {
    props:['view','data','memberid'],
    data() {
        return {
            authshow:false,
            authmemberid:'',
            authinfo:{}
        }
    },
    watch: {
        view(val){
            if(val) {
                this.authshow=true;
                this.authmemberid=this.memberid;
                this.authinfo=this.data;    
            }
        },
    },
    mounted() {
        
    },
    methods: {

        /** 关闭窗口 **/
        handleClose() {
            this.authshow=false;
            this.$emit('finish');
        },

    },
}
</script>
<style scoped>
.auth-box {display: inline-block;width:100%;}
.auth-box-item {display: inline-flex;align-items: center;width:100%;position:relative;}
.auth-title {display: inline-flex;align-items: center;font-size:16px;font-weight: bold;}
.auth-title span {font-size:12px;line-height: 12px;color:#666666;padding:4px 10px;border-radius: 20px;border:1px solid #666666;font-weight: normal;}
.auth-status {color:#ffffff !important;background-color: #666eeb;border-color:#666eeb !important;}
.auth-box-content-title {display: inline-block;font-size:13px;color:#333333;width:25%;}
.auth-box-content {display: inline-block;font-size:13px;color:#333333;}
.auth-error {font-size:13px;color:red !important;border:none !important;}
.TTL-btn-box {display: inline-flex;justify-content: flex-end;align-items: center;width:100%;margin-bottom:20px;}
</style>